import { DeliveryMethodDefinitionIdentifier, RestApiDeliveryMethodDto } from '@order-mage/integration-sdk';
import { isDeliveryMethod } from '@/entities/venue/lib/isDeliveryMethod';

export const isPickupOrder = (
    order: {
        deliveryMethodId?: string;
        deliveryMethod?: { deliveryMethodDefinition?: { identifier?: string } } | null;
    },
    deliveryMethods?: RestApiDeliveryMethodDto[] | null,
): boolean => {
    const method = deliveryMethods?.find((m) => m.id === order.deliveryMethodId);
    if (method) return !isDeliveryMethod(method);
    // Fallback: order.deliveryMethod has no areas, so use identifier when the venue method isn't in the list
    const id = order.deliveryMethod?.deliveryMethodDefinition?.identifier;
    return (
        id === DeliveryMethodDefinitionIdentifier.PICK_UP || id === DeliveryMethodDefinitionIdentifier.DINE_IN
    );
};
